<!-- Inbox Drawer -->
<nz-drawer
  appSwipeToClose
  (swipeClosed)="dock.closeInbox()"
  [nzPlacement]="drawerPlacement()"
  [nzVisible]="dock.inboxOpen()"
  [nzClosable]="true"
  [nzMask]="true"
  [nzWidth]="drawerWidth()"
  [nzHeight]="drawerHeight()"
  (nzOnClose)="dock.closeInbox()"
  [nzTitle]="inboxDrawerTitle"
  [nzBodyStyle]="{ padding: '0' }"
  [nzWrapClassName]="isMobile() ? 'utility-dock-drawer utility-dock-drawer--fullscreen utility-dock-drawer--sheet' : 'utility-dock-drawer'">
  <ng-container *nzDrawerContent>
    <div cdkTrapFocus cdkTrapFocusAutoCapture class="utility-dock">
      <app-inbox />
      
      <!-- Mobile close button -->
      <app-drawer-mobile-close
        [closeLabel]="'activity.inbox.close'"
        (close)="dock.closeInbox()"
      />
    </div>
  </ng-container>
</nz-drawer>

<!-- Notifications Drawer -->
<nz-drawer
  appSwipeToClose
  (swipeClosed)="dock.closeNotifications()"
  [nzPlacement]="drawerPlacement()"
  [nzVisible]="dock.notificationsOpen()"
  [nzClosable]="true"
  [nzMask]="true"
  [nzWidth]="drawerWidth()"
  [nzHeight]="drawerHeight()"
  (nzOnClose)="dock.closeNotifications()"
  [nzTitle]="notificationsDrawerTitle"
  [nzBodyStyle]="{ padding: '0' }"
  [nzWrapClassName]="isMobile() ? 'utility-dock-drawer utility-dock-drawer--fullscreen utility-dock-drawer--sheet' : 'utility-dock-drawer'">
  <ng-container *nzDrawerContent>
    <div cdkTrapFocus cdkTrapFocusAutoCapture class="utility-dock">
      <app-notifications />
      
      <!-- Mobile close button -->
      <app-drawer-mobile-close
        [closeLabel]="'activity.notifications.close'"
        (close)="dock.closeNotifications()"
      />
    </div>
  </ng-container>
</nz-drawer>

<!-- Private Tasks Drawer -->
<nz-drawer
  appSwipeToClose
  (swipeClosed)="dock.closePrivateTasks()"
  [nzPlacement]="drawerPlacement()"
  [nzVisible]="dock.privateTasksOpen()"
  [nzClosable]="true"
  [nzMask]="true"
  [nzWidth]="drawerWidth()"
  [nzHeight]="drawerHeight()"
  (nzOnClose)="dock.closePrivateTasks()"
  [nzTitle]="privateTasksDrawerTitle"
  [nzBodyStyle]="{ padding: '0' }"
  [nzWrapClassName]="isMobile() ? 'utility-dock-drawer utility-dock-drawer--fullscreen utility-dock-drawer--sheet' : 'utility-dock-drawer'">
  <ng-container *nzDrawerContent>
    <div cdkTrapFocus cdkTrapFocusAutoCapture class="utility-dock">
      <app-private-task-rail></app-private-task-rail>

      <app-drawer-mobile-close
        [closeLabel]="'activity.privateTasks.close'"
        (close)="dock.closePrivateTasks()"
      />
    </div>
  </ng-container>
</nz-drawer>

<ng-template #inboxDrawerTitle>
  <div class="utility-dock__title-block">
    <span class="utility-dock__title-row utility-dock__title-row--between">
      <span class="utility-dock__title-row">
        <span class="utility-dock__title-icon" aria-hidden="true">
          <nz-icon nzType="inbox"></nz-icon>
        </span>
        <span class="utility-dock__title">{{ 'activity.inbox.title' | translate }}</span>
        <span class="utility-dock__count" *ngIf="getInboxCount() > 0">{{ getInboxCount() }}</span>
      </span>

      <button
        nz-button
        nzType="default"
        nzSize="small"
        type="button"
        class="utility-dock__title-action  desktop-button"
        (click)="focusPrivateTaskComposer()"
        [attr.aria-label]="'app.add_private_task' | translate"
      >
        <nz-icon nzType="plus"></nz-icon>
        {{ 'app.private_task' | translate }}
      </button>
    </span>
    <span class="utility-dock__subtitle">{{ 'app.offene_aufgaben_und_persnliche_todos' | translate }}</span>
  </div>
</ng-template>

<ng-template #privateTasksDrawerTitle>
  <div class="utility-dock__title-block">
    <span class="utility-dock__title-row">
      <span class="utility-dock__title-icon" aria-hidden="true">
        <nz-icon nzType="lock"></nz-icon>
      </span>
      <span class="utility-dock__title">{{ 'app.private_tasks_4' | translate }}</span>
    </span>
    <span class="utility-dock__subtitle">{{ 'app.personal_reminders_that_do_not_take' | translate }}</span>
  </div>
</ng-template>

<ng-template #notificationsDrawerTitle>
  <div class="utility-dock__title-block">
    <span class="utility-dock__title-row utility-dock__title-row--between">
      <span class="utility-dock__title-row">
        <span class="utility-dock__title-icon utility-dock__title-icon--notifications" aria-hidden="true">
          <nz-icon nzType="bell"></nz-icon>
        </span>
        <span class="utility-dock__title">{{ 'activity.notifications.title' | translate }}</span>
        <span class="utility-dock__count utility-dock__count--notifications" *ngIf="getNotificationsCount() > 0">
          {{ getNotificationsCount() }}
        </span>
      </span>

      <button
        *ngIf="getNotificationsCount() > 0"
        nz-button
        nzType="text"
        nzSize="small"
        type="button"
        class="utility-dock__title-action utility-dock__title-action--quiet  desktop-button"
        nz-tooltip
        [nzTooltipTitle]="'activity.notifications.mark_all_read' | translate"
        (click)="markAllNotificationsRead()"
        [attr.aria-label]="'activity.notifications.mark_all_read' | translate"
      >
        <nz-icon nzType="check"></nz-icon>
        <span class="utility-dock__title-action-label">{{ 'activity.notifications.mark_all_read_short' | translate }}</span>
      </button>
    </span>
    <span class="utility-dock__subtitle">{{ 'app.neueste_hinweise_erwhnungen_und_zuweisungen' | translate }}</span>
  </div>
</ng-template>
